import React from 'react'
import { Typography, Button } from '@material-ui/core'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import { ReactComponent as ErrorIcon } from 'app/components/icons/MaintenanceError.svg'
import { useAppName } from 'commons/usePartner'

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 'auto',
    height: 'fit-content',
  },
  logoImage: {
    width: '400px',
  },
  title: {
    color: '#1673b0',
    fontSize: '18px',
    paddingTop: '30px',
  },
  text: {
    color: '#404040',
    fontSize: '14px',
  },
}))

const MaintenanceErrorView = (props) => {
  const { icon, title, subtitle, action, actionText, ...rest } = props
  const classes = useStyles()
  const appName = useAppName()

  return (
    <div
      className={clsx(
        classes.root,
        'flex flex-col items-center text-center py-64',
      )}
      {...rest}
    >
      <ErrorIcon className={clsx('mb-16', classes.logoImage)} />
      <Typography
        variant="h5"
        className={`font-bold mb-8 ${clsx(classes.title)}`}
      >
        We’ll be back soon!
      </Typography>
      <Typography variant="subtitle1" className={`${clsx(classes.text)}`}>
        {appName} is currently unavailable while we make upgrades to improve our
        service to you.
      </Typography>

      {action ? (
        <Button
          color="secondary"
          variant="contained"
          className="mt-24"
          onClick={action}
        >
          {actionText || (
            <FormattedMessage id="errorView.actionButton.tryAgain" />
          )}
        </Button>
      ) : null}
    </div>
  )
}

MaintenanceErrorView.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  action: PropTypes.func,
  actionText: PropTypes.string,
}

export default MaintenanceErrorView
